import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useAllMyCoursesData, MY_COURSES_MODE } from 'Domain/MyCourseData';
import { useSearchMyCourseProvider } from 'Context/SearchMyCourseProvider';
import { myProfile } from 'Redux/user-profile/selectors';

import { QueryComponent } from '../../GraphQL';
import { getMyExternalProfileInfo } from '../../GraphQL/query/MyProfile.query';
import MenuView from '../../Components/Menu';

const Menu = ({ userId, ...restProps }) => {
  const { searchTerm, resetSearchTerm } = useSearchMyCourseProvider();
  const { data: myCourses, loading } = useAllMyCoursesData({
    mode: MY_COURSES_MODE.ALL,
    skip: !userId,
  });

  if (loading || !userId) return null;

  return (
    <QueryComponent query={getMyExternalProfileInfo}>
      {({ myExternalProfile }) => {
        const { providerName } = myExternalProfile || {};
        return (
          <MenuView
            providerName={providerName}
            hasMenuBackground={myCourses?.length === 0}
            searchTerm={searchTerm}
            resetSearchTerm={resetSearchTerm}
            {...restProps}
          />
        );
      }}
    </QueryComponent>
  );
};

Menu.propTypes = {
  userId: PropTypes.string,
};

export default connect((state) => {
  const user = myProfile(state);
  return {
    userId: user?.id,
  };
}, {})(Menu);
